module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik05IDEzSDExVjE1SDlWMTNaTTkgNUgxMVYxMUg5VjVaTTkuOTkgMEM0LjQ3IDAgMCA0LjQ4IDAgMTBDMCAxNS41MiA0LjQ3IDIwIDkuOTkgMjBDMTUuNTIgMjAgMjAgMTUuNTIgMjAgMTBDMjAgNC40OCAxNS41MiAwIDkuOTkgMFpNMTAgMThDNS41OCAxOCAyIDE0LjQyIDIgMTBDMiA1LjU4IDUuNTggMiAxMCAyQzE0LjQyIDIgMTggNS41OCAxOCAxMEMxOCAxNC40MiAxNC40MiAxOCAxMCAxOFoiIGZpbGw9IiMzMjMyMzIiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice.svg
// module id = bp3Z
// module chunks = 1